<template>
    <div id="address-add">
        <div id="receive-address-header">
            <span class="receive-address-title">添加新地址</span>
        </div>

        <div id="address-add-item">
            <div class="address-input">
                <div class="address-title">收货人</div>
                <input v-model="consignee" type="text" class="item-input" placeholder="请输入收货人姓名" maxlength="15" minlength="2">
            </div>

            <div class="address-input">
                <div class="address-title">电话</div>
                <input v-model="mobile" type="tel" class="item-input" placeholder="请输入电话号码" maxlength="11">
            </div>

            <div class="address-input" @click="selectAddress">
                <div class="address-title">地址</div>
                <input v-model="area" type="text" class="item-input" style="float: left;" placeholder="请选择收货地址"  readonly @click="selectAddress"/>
                <img class="address-title-next" src="../../assets/common_next.png" alt="">
            </div>

            <div class="address-input">
                <div class="address-title">门牌号</div>
                <input v-model="address" type="text" class="item-input" placeholder="例：1号楼101室" maxlength="30">
            </div>

            <div class="default-address">
                <input v-model="isDefault" type="checkbox" class="address-switch">
                <div class="default-address">设为默认地址</div>
            </div>
        </div>

        <button id="address-add-new-address" @click="saveAddress" :disabled="btnDisable">
            保存地址
        </button>
        <div class="back-btn" @click="backBtn">返回</div>

        <base-dialog v-show="messageVisible" :title="title" width="80%" @close="close">
            <p>{{ message }}</p>
        </base-dialog>

        <div class="toast" v-show="toastShow">
            {{toastText}}
        </div>
    </div>
</template>

<script>

    import {AddAddress, EditAddress} from "../../api/Address";
    import {AddressInfo} from "@/api/Address";
    import BaseDialog from "@/components/BaseDialog";
    import {isChinese} from "@/unitls";

    export default {
        name: "AddressAdd",
        components: {BaseDialog},
        data() {
            return {
                addressId: this.$route.query.id,
                consignee: '',
                mobile: '',
                area: '',
                address: '',
                isDefault: false,
                distributionCenterId: '',
                lat: '',
                lng: '',

                toastShow: false,
                toastText: '',

                title: '提示',
                messageVisible: false,
                message: "",

                isSuccess: false,

                btnDisable: false,
            }
        },

        mounted() {
            this.addressInfo();



        },

        methods: {
            close() {
                this.messageVisible = false;
                this.$emit('close');
            },

            toast (e) {
                let _that = this;
                this.toastText = e;
                this.toastShow = true;
                setTimeout(function(){
                    _that.toastShow = false;
                    if (_that.isSuccess) {
                        _that.$router.go(-1);
                    }
                }, 1000)
            },

            addressInfo() {
                let consignee = localStorage.getItem('consignee');
                let mobile = localStorage.getItem('mobile');
                let distributionCenterId = localStorage.getItem('distributionId');
                let area = localStorage.getItem('area');
                let address = localStorage.getItem('address');
                let lat = localStorage.getItem('lat');
                let lng = localStorage.getItem('lng');
                if (this.addressId === undefined) {
                    if (consignee) {
                        this.consignee = consignee;
                    }
                    if (mobile) {
                        this.mobile = mobile;
                    }
                    if (distributionCenterId) {
                        this.distributionCenterId = distributionCenterId;
                    }
                    if (area) {
                        this.area = area;
                    }
                    if (address) {
                        this.address = address;
                    }
                    if (lat) {
                        this.lat = lat;
                    }
                    if (lng) {
                        this.lng = lng;
                    }
                    return;
                }
                AddressInfo(this.addressId)
                    .then((response) => {
                        if (response.code === this.$API_CODE.OK) {
                            this.addressId = response.data.id;
                            this.consignee = response.data.consignee;
                            this.area = response.data.area;
                            // this.mobile = response.data.mobile;
                            this.address = response.data.address;
                            this.isDefault = response.data.default;
                            this.distributionCenterId = response.data.distributionCenterId;
                            let coor = response.data.coordinateList;
                            this.lat = coor[0];
                            this.lng = coor[1];
                            let areaStr = localStorage.getItem('area');
                            if (areaStr !== '') {
                                this.area = areaStr;
                            }
                            if (consignee) {
                                this.consignee = consignee;
                            }
                            if (mobile) {
                                this.mobile = mobile;
                            }
                            if (distributionCenterId) {
                                this.distributionCenterId = distributionCenterId;
                            }
                            if (area) {
                                this.area = area;
                            }
                            if (address) {
                                this.address = address;
                            }
                            if (lat) {
                                this.lat = lat;
                            }
                            if (lng) {
                                this.lng = lng;
                            }
                        }
                    })
            },



            selectAddress() {
                this.$router.push({path: '/selectAddress'}).catch(err => { err });

                //缓存当前页输入的数据
                localStorage.setItem('consignee', this.consignee);
                localStorage.setItem('mobile', this.mobile);
                localStorage.setItem('distributionId', this.distributionCenterId);
                localStorage.setItem('area', this.area);
                localStorage.setItem('address', this.address);
            },

            saveAddress() {
                if (this.consignee === '') {
                    this.toast('请输入收货人姓名');
                    return;
                }
                if (!isChinese(this.consignee)) {
                    this.toast('收货人姓名必须是汉字');
                    return;
                }
                if (this.consignee.trim().length < 2) {
                    this.toast('收货人姓名必须在2-15位');
                    return;
                }
                if (this.mobile === '') {
                    this.toast('请输入电话号码');
                    return;
                }

                let telReg = /^1[3456789]\d{9}$/;
                if (!telReg.test(this.mobile)) {
                    this.toast("请输入正确的电话号码");
                    return;
                }
                if (this.area === '') {
                    this.toast('请选择地址');
                    return;
                }
                if (this.address === '') {
                    this.toast('请输入门牌号');
                    return;
                }
                if (this.isDefault === '') {
                    this.isDefault = false;
                }

                if (this.distributionCenterId === '' || this.lat === '') {
                    this.toast('地址所属配送范围无效，请重新选择');
                    return;
                }

                this.btnDisable = true;
                if (this.addressId === undefined) {
                    AddAddress(this.consignee, this.area, this.address, this.mobile, this.distributionCenterId, this.lat,this.lng, this.isDefault)
                        .then(response => {
                            if (response.code === this.$API_CODE.OK) {
                                this.toast('地址添加成功');
                                this.isSuccess = true;
                            } else {
                                this.messageVisible = true;
                                this.message = response.message;
                            }
                            this.btnDisable = false;
                        });
                } else {
                    EditAddress(this.addressId, this.consignee, this.area, this.address, this.mobile, this.distributionCenterId, this.lat,this.lng, this.isDefault)
                        .then(response => {
                            if (response.code === this.$API_CODE.OK) {
                                this.toast('地址修改成功');
                                this.isSuccess = true;
                            } else {
                                this.messageVisible = true;
                                this.message = response.message;
                            }
                            this.btnDisable = false;
                        })
                }

            },


            backBtn() {
                this.$router.go(-1);
            }

        }
    }
</script>

<style lang="scss" scoped>
    #address-add {
        height: 100%;
        width: 100%;
        position: absolute;
        background: #fdf9f7;

        //header区域
        #receive-address-header {
            height: 6rem;
            line-height: 35px;
            background: url("../../assets/detail.png") no-repeat;
            background-size: 100%  6rem;
            width: 100%;

            .receive-address-title {
                color: white;
                float: right;
                margin-right: 20px;
                margin-top: 2rem;
                font-weight: bold;
                font-size: 1rem;
            }
        }

        #address-add-item {
            margin-top: 10px;

            .address-input {
                height: 3rem;
                margin-top: 10px;
                text-align: left;
                line-height: 3rem;
                padding-left: 20px;
                padding-right: 20px;
                border-top: 1px solid #dddddd;
                border-bottom: 1px solid #dddddd;
                background: #FFFFFF;

                .address-title {
                    width: 4rem;
                    height: 3rem;
                    float: left;
                    font-size: 0.9rem;
                }

                .item-input {
                    border: 0;
                    font-size: 0.9rem;
                    color: #000000;
                    height: 2.8rem;
                    background: unset;
                    width: 60%;
                }

                .address-title-next {
                    float: right;
                    margin-top: 15px;
                    margin-bottom: 15px;
                }
            }

            .default-address {
                text-align: left;
                margin-left: 1rem;
                font-size: 0.9rem;

                .address-switch {
                    float: left;
                }

                .default-address {
                    margin-top: 10px;
                    margin-left: 20px;
                    padding-top: 5px;
                }

                /* Switch开关样式 */
                /* 必须是input为 checkbox class 添加 switch 才能实现以下效果 */
                input[type='checkbox'].address-switch {
                    outline: none;
                    appearance: none;
                    -webkit-appearance: none;
                    -moz-appearance: none;
                    position: relative;
                    width: 2.5rem;
                    height: 1.25rem;
                    background: #ccc;
                    border-radius: 10px;
                    transition: border-color .3s, background-color .3s;
                }

                input[type='checkbox'].address-switch::after {
                    content: '';
                    display: inline-block;
                    width: 1rem;
                    height: 1rem;
                    border-radius: 50%;
                    background: #fff;
                    transition: .4s;
                    top: 2px;
                    position: absolute;
                    left: 2px;
                    font-size: 0.9rem;
                }

                input[type='checkbox'].address-switch:checked {
                    background: #ea2d53;
                }

                /* 当input[type=checkbox]被选中时：伪元素显示下面样式 位置发生变化 */
                input[type='checkbox'].address-switch:checked::after {
                    content: '';
                    position: absolute;
                    left: 55%;
                    top: 2px;
                }
            }

        }

        #address-add-new-address {
            height: 3rem;
            line-height: 1.5rem;
            background: #ea2d53;
            right: 0;
            bottom: 0;
            left: 0;
            width: 50%;
            position: fixed;
            z-index: 1;
            color: #FFFFFF;
            font-size: 1rem;
            border: none;
            border-radius: 0;
        }

        .back-btn {
            position: fixed;
            z-index: 1;
            right: 0;
            bottom: 0;
            background: #fdf9f7;
            margin: auto;
            width: 50%;
            font-size: 1rem;
            font-weight: bold;
            color: #ea2d53;
            border: 1px solid #ea2d53;
            height: 3rem;
            line-height: 3rem;
        }
    }
</style>